import "./style.scss";
import { FC, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import DocumentSvg from "@/src/svg/applicationsPage/APPopUp/Documents/DocumentSvg";
import {
  getDocumentPreviewKind,
  getDocumentTypeLabel,
  resolveFileExtension,
} from "@/src/utils/documentPreviewUtils";

pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();

const PDF_DOCUMENT_OPTIONS = {
  httpHeaders: {
    "ngrok-skip-browser-warning": "1",
  },
};

interface DocumentPreviewThumbnailProps {
  fileUrl: string;
  fileExtension?: string;
  fileName?: string;
  filePath?: string;
  className?: string;
}

const DocumentPreviewThumbnail: FC<DocumentPreviewThumbnailProps> = ({
  fileUrl,
  fileExtension,
  fileName,
  filePath,
  className = "",
}) => {
  const extension = resolveFileExtension(fileExtension, fileName, filePath, fileUrl);
  const previewKind = getDocumentPreviewKind(extension);
  const typeLabel = getDocumentTypeLabel(extension);
  const [imageFailed, setImageFailed] = useState(false);

  if (!fileUrl) {
    return (
      <div className={`document-preview-thumbnail placeholder ${className}`.trim()}>
        <div className="document-preview-thumbnail-placeholder-card">
          <DocumentSvg />
          <span>{typeLabel}</span>
        </div>
      </div>
    );
  }

  const showPlaceholder = previewKind === "unsupported" || (previewKind === "image" && imageFailed);

  if (showPlaceholder) {
    return (
      <div className={`document-preview-thumbnail placeholder ${className}`.trim()}>
        <div className="document-preview-thumbnail-placeholder-card">
          <DocumentSvg />
          <span>{previewKind === "image" && imageFailed ? "IMG" : typeLabel}</span>
        </div>
      </div>
    );
  }

  if (previewKind === "image") {
    return (
      <div className={`document-preview-thumbnail image ${className}`.trim()}>
        <img src={fileUrl} alt={fileName ?? "Document preview"} onError={() => setImageFailed(true)} />
      </div>
    );
  }

  return (
    <div className={`document-preview-thumbnail pdf ${className}`.trim()}>
      <Document file={fileUrl} options={PDF_DOCUMENT_OPTIONS}>
        <Page pageNumber={1} renderAnnotationLayer={false} renderTextLayer={false} />
      </Document>
    </div>
  );
};

export default DocumentPreviewThumbnail;
